namespace GeniuzPOS.SalePromoCamp {
    export namespace PsPromoCampaignService {
        export const baseUrl = 'SalePromoCamp/PsPromoCampaign';

        export declare function Create(request: Serenity.SaveRequest<PsPromoCampaignRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsPromoCampaignRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsPromoCampaignRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsPromoCampaignRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "SalePromoCamp/PsPromoCampaign/Create",
            Update = "SalePromoCamp/PsPromoCampaign/Update",
            Delete = "SalePromoCamp/PsPromoCampaign/Delete",
            Retrieve = "SalePromoCamp/PsPromoCampaign/Retrieve",
            List = "SalePromoCamp/PsPromoCampaign/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsPromoCampaignService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
